/* GCLB Modern Experience Pack v2 (added by Claude)
   Loaded from snippets/doc-head-core.liquid — remove the two include lines there to disable.
   v2: adds header logo intro animation (plays once per browser session). */
(function () {
  'use strict';
  var d = document;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    d.documentElement.classList.add('gclbm-init');

    /* 1. Scroll progress bar */
    try {
      if (!reduced) {
        var bar = d.createElement('div');
        bar.className = 'gclbm-progress';
        d.body.appendChild(bar);
        var ticking = false;
        var upd = function () {
          var h = d.documentElement;
          var max = h.scrollHeight - h.clientHeight;
          var p = max > 0 ? (window.pageYOffset || h.scrollTop) / max : 0;
          bar.style.transform = 'scaleX(' + Math.min(Math.max(p, 0), 1) + ')';
          ticking = false;
        };
        window.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; requestAnimationFrame(upd); }
        }, { passive: true });
        upd();
      }
    } catch (e) {}

    /* 2. Header logo intro — plays once per browser session */
    try {
      if (!reduced && !sessionStorage.getItem('gclbmLogo')) {
        var logo = d.querySelector('.logo-area__middle__inner a, .pageheader .logo, .mainlogo, .logo-area a');
        if (logo) {
          logo.classList.add('gclbm-logo-in');
          sessionStorage.setItem('gclbmLogo', '1');
          setTimeout(function () { logo.classList.remove('gclbm-logo-in'); }, 1200);
        }
      }
    } catch (e) {}

    /* 3. Scroll reveal with per-row stagger */
    try {
      if (!reduced && 'IntersectionObserver' in window) {
        var sel = '.product-block, .collection-block, .multi-column__item, .logo-list__item, .testimonial-block, #content .shopify-section h2, .image-with-text__inner, .rich-text__inner';
        var els = Array.prototype.slice.call(d.querySelectorAll(sel)).filter(function (el) {
          return !el.hasAttribute('data-cc-animate') && !el.closest('[data-cc-animate]') && !el.closest('.slideshow') && !el.closest('.slider');
        });
        var parents = [];
        var counts = [];
        els.forEach(function (el) {
          var p = el.parentNode;
          var i = parents.indexOf(p);
          if (i === -1) { parents.push(p); counts.push(0); i = parents.length - 1; }
          el.style.setProperty('--gclbm-d', Math.min(counts[i], 7) * 70 + 'ms');
          counts[i]++;
          el.classList.add('gclbm-reveal');
        });
        var done = function (el) {
          el.classList.remove('gclbm-reveal');
          el.classList.remove('gclbm-in');
          el.style.removeProperty('--gclbm-d');
        };
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            var el = en.target;
            io.unobserve(el);
            el.classList.add('gclbm-in');
            /* clean up after the animation so hover effects & theme styles take back over */
            setTimeout(function () { done(el); }, 1400);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
        els.forEach(function (el) { io.observe(el); });
      }
    } catch (e) {}

    /* 4. Fly-to-cart dot + cart icon bounce */
    try {
      var cartIcon = function () {
        return d.querySelector('.section-header a[href*="/cart"], .pageheader a[href*="/cart"], a[href="/cart"]');
      };
      d.addEventListener('click', function (ev) {
        if (reduced || !ev.target || !ev.target.closest) return;
        var btn = ev.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
        if (!btn) return;
        var icon = cartIcon();
        if (!icon || !Element.prototype.animate) return;
        var b = btn.getBoundingClientRect();
        var c = icon.getBoundingClientRect();
        if (!b.width || !c.width) return;
        var dot = d.createElement('span');
        dot.className = 'gclbm-fly';
        dot.style.left = (b.left + b.width / 2 - 7) + 'px';
        dot.style.top = (b.top + b.height / 2 - 7) + 'px';
        d.body.appendChild(dot);
        var dx = (c.left + c.width / 2) - (b.left + b.width / 2);
        var dy = (c.top + c.height / 2) - (b.top + b.height / 2);
        var anim = dot.animate([
          { transform: 'translate(0,0) scale(1)', opacity: 1 },
          { transform: 'translate(' + (dx * 0.55) + 'px,' + (dy * 0.55 - 90) + 'px) scale(0.85)', opacity: 1, offset: 0.55 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.3)', opacity: 0.35 }
        ], { duration: 700, easing: 'cubic-bezier(.3,.7,.4,1)' });
        anim.onfinish = function () {
          if (dot.parentNode) dot.parentNode.removeChild(dot);
          icon.classList.remove('gclbm-cart-bounce');
          void icon.offsetWidth;
          icon.classList.add('gclbm-cart-bounce');
          setTimeout(function () { icon.classList.remove('gclbm-cart-bounce'); }, 650);
        };
      }, true);
    } catch (e) {}

    /* 5. Homepage animated wave divider (after the hero section) */
    try {
      if (d.body.classList.contains('template-index')) {
        var first = d.querySelector('#content .shopify-section');
        if (first && !d.querySelector('.gclbm-wave')) {
          var wavePath = 'M0,34 c150,-22 450,22 600,0 c150,-22 450,22 600,0 c150,-22 450,22 600,0 c150,-22 450,22 600,0 L2400,60 L0,60 Z';
          var wave = d.createElement('div');
          wave.className = 'gclbm-wave';
          wave.setAttribute('aria-hidden', 'true');
          wave.innerHTML =
            '<svg class="gclbm-wave__back" viewBox="0 0 2400 60" preserveAspectRatio="none"><path d="' + wavePath + '"/></svg>' +
            '<svg class="gclbm-wave__front" viewBox="0 0 2400 60" preserveAspectRatio="none"><path d="' + wavePath + '"/></svg>';
          first.parentNode.insertBefore(wave, first.nextSibling);
        }
      }
    } catch (e) {}
  });
})();
